import { Icon } from "@iconify/react/dist/iconify.js";
import styles from "../settings.module.css";
import { Grid } from "@mui/material";
import configData from "../../../utils/ConfigData.json";
import useStyles from "../styles";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../../components/PageTitle";
import { useUserState } from "../../../context/UserContext";

const ConfigPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { subscription } = useUserState();
  const subscriptionName = subscription?.pricing_plan?.name;

  return (
    <>
      <PageTitle
        title="Configuration"
        subtitle="You can make changes to your organisation’s account."
      />
      <div>
        {configData.map((section, index) => (
          <div key={index} className={`${styles.section}`}>
            <h3 className={`${styles.sectionTitle}`}>{section.heading}</h3>

            <Grid container spacing={2} className={styles.sectionGrid}>
              {section.items.filter(
                (item) => !item.conditional ||
                  subscriptionName === "Pro" ||
                  subscriptionName === "Enterprise" ||
                  subscriptionName === "Partner"
              ).map((item, idx) => (
                <Grid
                  key={idx}
                  item
                  lg={3}
                  md={4}
                  sm={6}
                  xs={12}
                >
                  <div className={`${styles.card} ${classes.card}`} onClick={() => navigate(item.link)}>
                    <span className={classes.icon}>
                      <Icon className={classes.iconColor} icon={item.icon} width="20" height="20" />
                    </span>
                    <h3 className={`${styles.cardTitle}`}>{item.name}</h3>

                    <span className={styles.arrowIcon}>
                      <Icon icon="line-md:arrow-right" width="23" height="23" />
                    </span>
                  </div>

                </Grid>
              ))}
            </Grid>
          </div>
        ))}
      </div>
    </>
  );
};

export default ConfigPage;
